import { render, staticRenderFns } from "./selectHuovs.vue?vue&type=template&id=d82d7bde&scoped=true"
import script from "./selectHuovs.vue?vue&type=script&lang=js"
export * from "./selectHuovs.vue?vue&type=script&lang=js"
import style0 from "./selectHuovs.vue?vue&type=style&index=0&id=d82d7bde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d82d7bde",
  null
  
)

export default component.exports